import { settingsReducers } from './reducers';
import { settingsSaga } from './sagas';

export { settingsReducers, settingsSaga };
